import { setAlert } from './alertSlice';
import { createSlice } from '@reduxjs/toolkit';
import * as REQUESTS from '../api/messageRequests';
import { loadUser } from './authSlice';

const initialState = {
  sentRequest: null,
  canceledRequest: null,
  acceptedRequest: null,
  rejectedRequest: null,
  loading: false,
};

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {
    setSentRequest(state, action) {
      state.sentRequest = action.payload;
      state.loading = false;
    },
    setCanceledRequest(state, action) {
      state.cancelRequest = action.payload;
      state.loading = false;
    },
    setAcceptedRequest(state, action) {
      state.acceptedRequest = action.payload;
      state.loading = false;
    },
    setRejectedRequest(state, action) {
      state.rejectedRequest = action.payload;
      state.loading = false;
    },
    setLoading(state) {
      state.loading = !state.loading;
    },
  },
});

export const {
  setAcceptedRequest,
  setLoading,
  setRejectedRequest,
  setSentRequest,
  setCanceledRequest,
} = messageSlice.actions;

export default messageSlice.reducer;

// thunks

export const sendRequest = (gamer) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.sendRequest(gamer.username);
    const { success, data } = resData;
    if (success) {
      dispatch(loadUser());
      dispatch(setSentRequest(gamer));
      dispatch(setAlert('Request sent!', 'success'));
    }
  } catch (err) {
    console.log(err);
    dispatch(setAlert(err.response.data.error, 'warning'));
  }
};

export const cancelRequest = (gamer) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.cancelRequest(gamer.username);
    const { success, data } = resData;
    if (success) {
      dispatch(loadUser());
      dispatch(setCanceledRequest(gamer));
      dispatch(setAlert('Request cancelled!', 'success'));
    }
  } catch (err) {
    console.log(err);
    dispatch(setAlert(err.response.data.error, 'warning'));
  }
};

export const acceptRequest = (gamer) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.acceptRequest(gamer.username);
    const { success, data } = resData;
    if (success) {
      dispatch(loadUser());
      dispatch(setAcceptedRequest(gamer));
      dispatch(setAlert('Request accepted!', 'success'));
    }
  } catch (err) {
    console.log(err);
    dispatch(setAlert(err.response.data.error, 'warning'));
  }
};

export const rejectRequest = (gamer) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const resData = await REQUESTS.rejectRequest(gamer.username);
    const { success, data } = resData;
    if (success) {
      dispatch(loadUser());
      dispatch(setRejectedRequest(gamer));
      dispatch(setAlert('Request rejected!', 'success'));
    }
  } catch (err) {
    console.log(err);
    dispatch(setAlert(err.response.data.error, 'warning'));
  }
};
